import { createRoot } from 'react-dom/client';
import { Provider as StoreProvider } from 'react-redux';

import store from '@App/app.store';
import App from './App/App';

import './index.styl';

const container = document.getElementById('js-mapframe');
const root = createRoot(container);

root.render(
  <StoreProvider store={store}>
    <App />
  </StoreProvider>,
);